const {enum_numbers} = require( "./Share_S_Enum");

// date_hoursFromTimestamp_fs
export const date_hoursFromTimestamp_fs = (timestamp_s ) => {

    let now = new Date()
    let date  = new Date(timestamp_s)

    return (now - date) / enum_numbers.millisecondsInHour
}

// date_addMinutesToDateTime_ft
export const date_addMinutesToDateTime_ft = (dateTime, minutesToAdd ) => {
    let endingDate = new Date(dateTime);

    endingDate.setMinutes(endingDate.getMinutes() + parseInt(minutesToAdd))
    return endingDate.getTime()
}

// date_nowTime_t
export const date_nowTime_t = () => {

    return (new Date()).getTime()
}

// date_intervalMillSec_ft
export const date_intervalMillSec_ft = (dateTime1, dateTime2 ) => {
    return dateTime1 - dateTime2
}

// date_previousMonth_fd
export const date_previousMonth_fd = () =>{
    let now_d = new Date();
    now_d.setMonth(now_d.getMonth()-1)

    return now_d
}

// date_get0am_t
export const date_get0am_t = (dateTime=null) => {

    let now_d = dateTime ? new Date(dateTime) : new Date()

    now_d.setHours(0)
    now_d.setMinutes(0)
    now_d.setSeconds(0)
    now_d.setMilliseconds(0)

    return now_d.getTime()
}

// date_nextMonthStartingDate_t
export const date_nextMonthStartingDate_d = (date_d) => {

    date_d.setMonth(date_d.getMonth() + 1)
    date_d.setDate(1)
    date_d.setHours(0)
    date_d.setMinutes(0)
    date_d.setSeconds(0)
    date_d.setMilliseconds(0)

    return date_d

}


